module.exports = __webpack_public_path__ + "./assets/97e41acbcc99fde61217b983eb4c4281.svg";